module.exports = __webpack_public_path__ + "assets/w3w_logo@3x-6f02dda197144f1dc2f5c2d172929baa.png";